import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-editable',
  templateUrl: './editable.component.html',
  styleUrls: ['./editable.component.scss']
})
export class EditableComponent implements OnInit {

  @Input() data: any;
  @Input() dataType: any;
  @Output() focusOut: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild('textarea') textAreaElement: ElementRef;
  @ViewChild('text') textElement: ElementRef;
  @ViewChild('number') numberElement: ElementRef;

  origin: any;
  currency = '$';
  editMode = false;

  constructor() {
    if (this.dataType === '' || this.dataType == undefined) {
      this.dataType = 'text';
    }
  }

  ngOnInit() {
    this.origin = this.data;
  }

  activeEdit() {
    this.editMode = true;

    if (this.dataType == "textarea") {
      setTimeout(() => { // this will make the execution after the above boolean has changed
        this.textAreaElement.nativeElement.select();
        document.execCommand("copy");
      }, 0);
    }
    else if (this.dataType == "text") {
      setTimeout(() => { // this will make the execution after the above boolean has changed
        this.textElement.nativeElement.select();
        document.execCommand("copy");
      }, 0);

    }else if (this.dataType == "number") {
      setTimeout(() => { // this will make the execution after the above boolean has changed
        if (this.data === 0) {
          this.data = undefined;
        }
        this.numberElement.nativeElement.select();
        //document.execCommand("copy");
      }, 0);
    }
  }

  onFocusOut() {
    if (this.dataType === "number" && (this.data == undefined || this.data == null)) {
      this.data = 0;
    }

    if (this.origin === this.data)
    {
      return;
    }

    this.focusOut.emit(this.data);
  }
}
